module.exports = __webpack_public_path__ + "img/cup-1.78b72d95.png";